import { NamedExoticComponent, ChangeEvent } from 'react'
import { PhoneInput, IPhoneInputProps } from 'transfix-ui/components/PhoneInput'
import { TextInput, ITextInputProps } from 'components/atoms'

export const components = { text: TextInput, phone: PhoneInput } as InputComponents

export enum validInputTypes {
  TEXT = 'text',
  PHONE = 'phone',
}

export interface InputComponents {
  text: NamedExoticComponent<ITextInputProps>
  phone: NamedExoticComponent<IPhoneInputProps>
}

export interface ITextInputField extends ITextInputProps {
  type: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  colSize: string
}

export interface IPhoneInputField extends IPhoneInputProps {
  type: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  colSize: string
  'data-test'?: string
}

export enum CARRIER_REFERENCE_KEYS {
  COMPANY_NAME = 'companyName',
  CONTACT_NAME = 'contactName',
  PHONE = 'phone',
  EMAIL = 'email',
}

export const displayKeys: CARRIER_REFERENCE_KEYS[] = [
  CARRIER_REFERENCE_KEYS.COMPANY_NAME,
  CARRIER_REFERENCE_KEYS.CONTACT_NAME,
  CARRIER_REFERENCE_KEYS.PHONE,
  CARRIER_REFERENCE_KEYS.EMAIL,
]
